import currencyFormat from "@/lib/currencyFormat";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
export default function TrendCard(props) {
  const { name, data, variant, height } = props;
  let trend = "up";
  const variance = ((data.value[0] - data.value[1]) / data.value[1]) * 100;
  const symbols = variance > 0 ? "+" : "";
  if (variance < 0) {
    trend = "down";
  }
  const labelColors = {
    up: "success",
    down: "error",
  };
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction="column"
          sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}
        >
          <Stack sx={{ justifyContent: "space-between" }}>
            <Stack
              direction="column"
              sx={{
                alignItems: "center",
              }}
            >
              <Typography noWrap align={"center"} variant="h6">
                {name}
              </Typography>
            </Stack>
          </Stack>

          <Stack sx={{ justifyContent: "center", height: height }}>
            <Stack
              direction="column"
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {variance ? (
                <>
                  <Typography
                    noWrap
                    align={"center"}
                    color={labelColors[trend]}
                    variant={variant}
                    sx={{ marginBottom: 1 }}
                  >
                    {symbols}
                    {variance.toFixed(1)}%
                  </Typography>
                  <Typography
                    noWrap
                    align={"center"}
                    variant="caption"
                    sx={{ color: "text.secondary" }}
                  >
                    {currencyFormat(data.value[0])} /{" "}
                    {currencyFormat(data.value[1])}
                  </Typography>
                </>
              ) : (
                <CircularProgress></CircularProgress>
              )}
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
